import React from 'react';
import { useTranslation } from 'react-i18next';
import { NotFound } from '../../templates/not-found';

const Index = () => {
    const { t } = useTranslation();

    return (
        <NotFound
            subtitle={t('notFound.subtitle', "We can't seem to find that page. Try visiting the home page.")}
            title={t('notFound.title', 'Oops!')}
        />
    );
};
export default Index;
